import { render, staticRenderFns } from "./pos_modal.vue?vue&type=template&id=b2c9d020&scoped=true&"
import script from "./pos_modal.vue?vue&type=script&lang=js&"
export * from "./pos_modal.vue?vue&type=script&lang=js&"
import style0 from "./pos_modal.vue?vue&type=style&index=0&id=b2c9d020&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c9d020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2c9d020')) {
      api.createRecord('b2c9d020', component.options)
    } else {
      api.reload('b2c9d020', component.options)
    }
    module.hot.accept("./pos_modal.vue?vue&type=template&id=b2c9d020&scoped=true&", function () {
      api.rerender('b2c9d020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/point_manage/point_rule/components/pos_modal.vue"
export default component.exports